var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGarageBookedOrdersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44187 18.875C1.92437 18.875 1.49237 18.7146 1.14587 18.3937C0.798625 18.0722 0.625 17.6719 0.625 17.1927V1.80729C0.625 1.32812 0.798625 0.928125 1.14587 0.607292C1.49237 0.285764 1.92437 0.125 2.44187 0.125H14.5581C15.0756 0.125 15.5076 0.285764 15.8541 0.607292C16.2014 0.928125 16.375 1.32812 16.375 1.80729V17.1927C16.375 17.6719 16.2017 18.0719 15.8552 18.3927C15.508 18.7142 15.0756 18.875 14.5581 18.875H2.44187ZM2.44187 17.8333H14.5581C14.7306 17.8333 14.8892 17.7667 15.034 17.6333C15.178 17.4993 15.25 17.3524 15.25 17.1927V1.80729C15.25 1.64757 15.178 1.50069 15.034 1.36667C14.8892 1.23333 14.7306 1.16667 14.5581 1.16667H13V7.53646L10.75 6.29479L8.5 7.53646V1.16667H2.44187C2.26937 1.16667 2.11075 1.23333 1.966 1.36667C1.822 1.50069 1.75 1.64757 1.75 1.80729V17.1927C1.75 17.3524 1.822 17.4993 1.966 17.6333C2.11075 17.7667 2.26937 17.8333 2.44187 17.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarageBookedOrdersIcon);
export default __webpack_public_path__ + "static/media/garage_booked_orders_icon.d2d06046612d169ab84352b123b4df8b.svg";
export { ForwardRef as ReactComponent };